import React from 'react';
import {
  ArrowBack as ArrowBackIcon,
  EmailOutlined as MessageIcon,
  EditOutlined as EditIcon,
} from '@mui/icons-material';
import { Box, Button, Chip, IconButton, Typography, useTheme } from '@mui/material';

interface ProviderDetailHeaderProps {
  name: string;
  email: string;
  status: string;
  onBack: () => void;
  onEditProfile?: () => void;
  onMessageUser?: () => void;
}

export const ProviderDetailHeader: React.FC<ProviderDetailHeaderProps> = ({
  name,
  email,
  status,
  onBack,
  onEditProfile,
  onMessageUser,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <IconButton onClick={onBack} size="small" sx={{ color: '#2D336B' }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
          {name}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={onEditProfile}
            sx={{
              textTransform: 'uppercase',
              fontWeight: 600,
              borderRadius: '8px',
              borderColor: '#2D336B',
              color: '#2D336B',
              '&:hover': {
                borderColor: '#1E2248',
                bgcolor: 'rgba(45, 51, 107, 0.04)',
              },
            }}
          >
            Edit Profile
          </Button>
          <Button
            variant="contained"
            startIcon={<MessageIcon />}
            onClick={onMessageUser}
            sx={{
              bgcolor: '#2D336B',
              textTransform: 'uppercase',
              fontWeight: 600,
              borderRadius: '8px',
              px: 3,
              '&:hover': {
                bgcolor: '#1E2248',
              },
            }}
          >
            Message User
          </Button>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 6 }}>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {email}
        </Typography>
        <Chip
          label={status}
          size="small"
          sx={{
            bgcolor: '#E8F5E9',
            color: '#2E7D32',
            fontWeight: 600,
            fontSize: '0.75rem',
            height: 24,
          }}
        />
      </Box>
    </Box>
  );
};

